import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doRedirectToNextStep),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSignupCardSagas);

import { push as updatePath } from 'react-router-redux';
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { setPathToPurchaseTest } from 'helpers/pathToPurchaseHelper';
export var redirectToNextStep = function redirectToNextStep(path) {
  return {
    type: 'SIGNUP_CARD_REDIRECT_TO_NEXT_STEP',
    path: path
  };
};
export function doRedirectToNextStep(_ref) {
  var path;
  return regeneratorRuntime.wrap(function doRedirectToNextStep$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          path = _ref.path;
          _context.next = 3;
          return call(setPathToPurchaseTest);

        case 3:
          _context.next = 5;
          return put(updatePath(path));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function watchSignupCardSagas() {
  return regeneratorRuntime.wrap(function watchSignupCardSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, redirectToNextStep().type, doRedirectToNextStep);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}